import { useTranslation } from "react-i18next";

import { Input } from "@unified-checkout/design-system";

import type { ICaptureModal } from "@app/dashboard/types/innerLayout/transactions/modals/capture";

import { AANI } from "../../utils";

import styles from './CaptureModalBody.module.scss'

const defaultText: ICaptureModal['localization'] = {
  maxCaptureAmount: 'Maximum amount that can be captured'
};

export const CaptureModalBody = ({
  loading,
  detailsList,
  maxCaptureAmount,
  captureAmountInput,
  localization = defaultText,
  paymentMethod = ''
}: ICaptureModal) => {
  const { t } = useTranslation();

  const captureNotes = [
    {
      condition: [AANI].includes(paymentMethod),
      content: t('innerLayout.transactionsPage.singleTransactionsPage.modals.capture.captureOneTimeNote'),
    },
  ];

  const activeNote = captureNotes.find((note) => note.condition);

  return (
    <div className={styles["transaction-info-box"]}>
      {
        detailsList &&
        <div className={styles["transaction-info-box__info"]}>
          {
            detailsList.map((item, index) => <div
              className={styles["transaction-info-box__info__item"]}
              key={`transaction-info-box-${index}`}
            >
              <span className={styles["transaction-info-box__info__item__label"]}>
                {`${item.label}: `}
              </span>
              <span className={styles["transaction-info-box__info__item__value"]}>
                {item.value}
              </span>
            </div>
            )
          }
        </div>
      }

      <div className={styles["transaction-info-box__max-capture-amount"]}>
        <span className={styles["transaction-info-box__max-capture-amount__label"]}>
          {`${localization?.maxCaptureAmount}: `}
        </span>
        <span className={styles["transaction-info-box__max-capture-amount__value"]}>
          {maxCaptureAmount}
        </span>
      </div>

      {
        captureAmountInput &&
        <Input
          type="number"
          name={captureAmountInput?.name || "capture-amount-field"}
          label={captureAmountInput?.label}
          value={captureAmountInput?.value}
          error={captureAmountInput?.error}
          disabled={loading}
          status={captureAmountInput?.error ? 'error' : 'default'}
          placeholder={captureAmountInput?.placeholder}
          onChange={captureAmountInput?.onChangeHandler}
          leadingText={captureAmountInput?.leadingText}
        />
      }

       {activeNote && (
        <p className={styles['transaction-info-box__note']}>
          {activeNote.content}
        </p>
      )}
    </div>
  )
};
